import { render, staticRenderFns } from "./sale_area_table.vue?vue&type=template&id=bf257d74&scoped=true"
import script from "./sale_area_table.vue?vue&type=script&lang=js"
export * from "./sale_area_table.vue?vue&type=script&lang=js"
import style0 from "./sale_area_table.vue?vue&type=style&index=0&id=bf257d74&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf257d74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf257d74')) {
      api.createRecord('bf257d74', component.options)
    } else {
      api.reload('bf257d74', component.options)
    }
    module.hot.accept("./sale_area_table.vue?vue&type=template&id=bf257d74&scoped=true", function () {
      api.rerender('bf257d74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/dms/views/contract/components/sale_area_table.vue"
export default component.exports